<template>
    <div
        class="app-header d-flex align-center"
        :class="
            display.smAndDown.value
                ? 'justify-space-between px-5 py-3'
                : 'pdx-60 py-3'
        "
    >
        <div>
            <a href="https://skolla.online/">
                <img :src="require('@/assets/images/logo.svg')" />
            </a>
        </div>

        <div
            v-if="display.mdAndUp.value"
            class="d-flex align-center gap-5 ml-10"
        >
            <v-btn
                v-for="(menu, i) in menus"
                :key="i"
                :color="existingPathName === menu.name ? '#0e97d6' : '#020672'"
                variant="text"
                @click="$router.push(menu.path)"
            >
                <span class="font-weight-600 font-size-16">
                    {{ menu.text }}
                </span>
            </v-btn>
        </div>

        <div v-if="display.smAndDown.value">
            <v-icon size="30">mdi-menu</v-icon>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['display'],
    data() {
        return {
            menus: [
                {
                    path: '/',
                    text: 'Paket Belajar',
                    name: 'Package',
                },
                {
                    path: '/cara-pembelian',
                    text: 'Cara Pembelian & Aktivasi',
                    name: 'HowToPurchase',
                },
            ],
        };
    },
    computed: {
        existingPathName() {
            return this.$route.name;
        },
    },
};
</script>

<style>
.app-header {
    position: fixed;
    z-index: 10 !important;
    width: 100%;
    background-color: #fff;
}
</style>
